import { useMutation, useQuery, useQueryClient } from 'react-query'

import { DeduplicationService } from '../services'
import type { TaskOwnerSetting } from '../types'

export const useDeduplicationSettings = () =>
  useQuery(['deduplication-settings'], () => DeduplicationService.getSettings())

export const useHubspotOwners = (q?: string) =>
  useQuery(['deduplication-hubspot-owners', q ?? ''], () =>
    DeduplicationService.listHubspotOwners(q)
  )

export const useUpdateTaskOwner = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (taskOwner: TaskOwnerSetting) => DeduplicationService.updateTaskOwner(taskOwner),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['deduplication-settings'])
      },
    }
  )
}

export const useUpdateReviewTasksEnabled = () => {
  const queryClient = useQueryClient()

  return useMutation((enabled: boolean) => DeduplicationService.updateReviewTasksEnabled(enabled), {
    onSuccess: () => {
      queryClient.invalidateQueries(['deduplication-settings'])
    },
  })
}

export const useClearCrawlCache = () => useMutation(() => DeduplicationService.clearCrawlCache())

export const useNukeDomainCache = () => useMutation(() => DeduplicationService.nukeDomainCache())
